import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
//Dialog
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Box,
  Grid,
  Stack,
  Button,
  Select,
  MenuItem,
  TextField,
  IconButton,
  Typography,
  FormControl,
  DialogActions,
  FormHelperText,
  InputAdornment,
} from "@mui/material";
import "../../Style/dialogstyle.scss";
import ListPayment from "./ListPayment";
import { useMutation } from "@apollo/client";
import { BiMinusCircle } from "react-icons/bi";
import { AuthContext } from "../../Context/AuthContext";
import { SelectCustomer } from "../Include/DynamicSelect";
import { translateLauguage } from "../../Function/Translate";
import { CREAE_GENERAL_INVOICE } from "../../Schema/Generalincome";


export default function CreateGeneralIncome({ open, handleClose, setRefetch }) {
  // Change Language
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [loading, setLoading] = useState(false);
  const [required, setRequired] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState({ id: "", title: "" });
  const paymentItem = {
    memo: "",
    amount: 0,
    endDate: null,
    startDate: null,
    item: { id: "", title: "" },
    key: Date.now() + Math.random(),
  }
  const [listPaymentData, setListPaymentData] = useState([paymentItem]);
  const [createGeneralInvoice] = useMutation(CREAE_GENERAL_INVOICE, {
    onCompleted: ({ createGeneralInvoice }) => {
      setLoading(false);
      if (createGeneralInvoice?.status === true) {
        setAlert(true, "success", createGeneralInvoice?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createGeneralInvoice?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const Validate = Yup.object().shape({
    billTo: Yup.string().required("required!"),
    currency: Yup.string().required("required!"),
    exchangeRate: Yup.number().required("required!"),
  });

  const formik = useFormik({
    initialValues: {
      billTo: "",
      currency: "USD",
      exchangeRate: 4000,
    },
    validationSchema: Validate,
    onSubmit: async (values) => {

      if (listPaymentData.length === 0) {
        setRequired(false);
        setListPaymentData([paymentItem]);
        return;
      }

      const checkError = [];
      const itemData = listPaymentData.map((e) => {
        if (!e?.amount || !e?.item?.id || !e?.endDate || !e?.startDate) checkError.push(true);
        return {
          key: e?.key,
          amount: e?.amount,
          itemId: e?.item?.id,
          description: e?.memo,
          endDate: moment(e?.endDate).format("YYYY-MM-DD"),
          startDate: moment(e?.startDate).format("YYYY-MM-DD"),
        }
      });


      if (checkError.length > 0) {
        setRequired(true);
        return;
      }

      setLoading(true);
      setRequired(false);
      createGeneralInvoice({
        variables: {
          input: {
            vat: 0, 
            ...values,
            vatAmount: 0,
            items: itemData,
            totalAmount: itemData.reduce((a, b) => a + (b?.amount || 0), 0),
          }
        },
      });
    },
  });

  const {
    errors,
    values,
    touched,
    resetForm,
    handleSubmit,
    getFieldProps,
    setFieldValue,
  } = formik;

  useEffect(() => {
    setFieldValue("billTo", selectedCustomer?.id);
  }, [selectedCustomer]);



  useEffect(() => {
    if (open) {
      resetForm();
      setListPaymentData([paymentItem]);
      setSelectedCustomer({ id: "", title: "" });
    }
  }, [open]);


  return (
    <Dialog open={open} className="dialog-container" maxWidth="md" fullWidth>
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              Add sales receipt
            </Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>

              <Grid item xs={4} md={4}>
                <Typography className="field-title">Currency</Typography>
                <FormControl className="text-field" fullWidth size="small">
                  <Select
                    value={values?.currency}
                    onChange={(e) => setFieldValue("currency", e?.target?.value)}
                  >
                    <MenuItem value="USD">USD</MenuItem>
                    <MenuItem value="KHR">KHR</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} md={4}>
                <Typography className="field-title">Exchange rate</Typography>
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment sx={{ mr: 1, ml: -0.5, }}>
                        1$ :
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment sx={{ mr: 1, ml: -0.5, }}>
                        ៛
                      </InputAdornment>
                    ),
                    inputProps: { min: 0, },
                  }}
                  fullWidth
                  size="small"
                  type="number"
                  className="text-field"
                  {...getFieldProps("exchangeRate")}
                  error={Boolean(touched.exchangeRate && errors.exchangeRate)}
                  helperText={touched.exchangeRate && errors.exchangeRate}
                />
              </Grid>

              <Grid item xs={6} md={4}>
                <Typography className="field-title">Bill To</Typography>
                <SelectCustomer selectedVal={selectedCustomer} setSelectedVal={setSelectedCustomer} />
                {!!errors.billTo && touched.billTo && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.billTo}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12}>
                <ListPayment
                  currency={values?.currency}
                  required={required}
                  listPaymentData={listPaymentData}
                  setListPaymentData={setListPaymentData}
                />

              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>

      <DialogActions >
        <Stack direction="row" justifyContent="right" width="100%" sx={{ padding: "10px" }}>
          {loading ? (
            <Button className="btn-create" fullWidth>
              {t("loading")}
            </Button>
          ) : (
            <Button
              className="btn-create"
              fullWidth
              onClick={handleSubmit}
            >
              {t("create")}
            </Button>
          )}
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
